import React, { useEffect, useState } from 'react'
import { useGetVideosQuery } from '../../features/video/videoApi'
import { useAddQuizMutation, useGetQuizByQuizIdAndVideoIdQuery } from '../../features/quiz/quizApi'
import Layout from '../../components/Layout'
// import swal from 'sweetalert'
import { useParams } from 'react-router-dom'
import EditQuizField from '../../components/EditQuizField'


export default function EditQuiz() {
  // swal("Successful", "Quiz add successful", "success");
  const { quizId, videoId } = useParams()
  // const dispatch = useDispatch()
  const { isSuccess: isSuccessFetchVideos, data: videos } = useGetVideosQuery()
  const { isSuccess: isSuccessFetchQuiz, data: quiz } = useGetQuizByQuizIdAndVideoIdQuery({ quizId, videoId })

  const [addQuiz, { isSuccess: isSuccessAddQuiz }] = useAddQuizMutation()

  const [quizOption1, setQuizOption1] = useState("")
  const [quizOption2, setQuizOption2] = useState("")
  const [quizOption3, setQuizOption3] = useState("")
  const [quizOption4, setQuizOption4] = useState("")

  const [checkBoxValue1, setCheckBoxValue1] = useState(false)
  const [checkBoxValue2, setCheckBoxValue2] = useState(false)
  const [checkBoxValue3, setCheckBoxValue3] = useState(false)
  const [checkBoxValue4, setCheckBoxValue4] = useState(false)

  const [quizQuestion, setQuizQuestion] = useState("")

  const [videoTitle, setVideoTitle] = useState("")

  useEffect(() => {
    if (isSuccessFetchQuiz && quiz.length > 0) {
      const { question, options, video_title } = quiz[0] || {}

      setQuizQuestion(question)

      setVideoTitle(video_title)

      setQuizOption1(options[0].option)
      setQuizOption2(options[1].option)
      setQuizOption3(options[2].option)
      setQuizOption4(options[3].option)

      setCheckBoxValue1(options[0].isCorrect)
      setCheckBoxValue2(options[1].isCorrect)
      setCheckBoxValue3(options[2].isCorrect)
      setCheckBoxValue4(options[3].isCorrect)
    }
  }, [isSuccessFetchQuiz, quiz])


  function handleCreateNewQuiz(e) {
    e.preventDefault();

    addQuiz({
      question: quizQuestion,
      video_title: videoTitle?.split("$@")[0],
      video_id: videoTitle?.split("$@")[1],
      options: [quizOption1, quizOption2, quizOption3, quizOption4]
    })
  }

  return (
    <Layout>
      <section className='py-6 bg-primary'>
        <div className='mx-auto max-w-full px-5 lg:px-20'>
          <form className='py-8'>
            <div className="mb-6">
              <input type="text" value={videoTitle} className="border rounded-lg  block w-full p-1 bg-gray-700 border-gray-600 placeholder-gray-400 text-white focus:ring-blue-500 focus:border-blue-500" required />
            </div>

            <div className='border my-4 rounded-md p-5'>
              <div className='mb-4'>
                <label htmlFor="quizQuestion" className="block mb-2 text-sm font-medium text-white">Write quiz question.</label>
                <input type="text" value={quizQuestion} onChange={e => setQuizQuestion(e.target.value)} name="quizQuestion" placeholder='Enter quiz question.' className="border rounded-lg  block w-full p-1 bg-gray-700 border-gray-600 placeholder-gray-400 text-white focus:ring-blue-500 focus:border-blue-500" required />
              </div>
              <div className="grid grid-cols-12 gap-6">
                <EditQuizField checkValue={checkBoxValue1} quizOptionValue={quizOption1} setQuizOption={setQuizOption1} id="1" />
                <EditQuizField checkValue={checkBoxValue2} quizOptionValue={quizOption2} setQuizOption={setQuizOption2} id="2" />
                <EditQuizField checkValue={checkBoxValue3} quizOptionValue={quizOption3} setQuizOption={setQuizOption3} id="3" />
                <EditQuizField checkValue={checkBoxValue4} quizOptionValue={quizOption4} setQuizOption={setQuizOption4} id="4" />
              </div>
            </div>

            <button type="submit" className="video-add-submit-btn text-white focus:ring-4 focus:outline-none font-medium rounded-lg text-sm px-5 py-2 text-center bg-blue-600 hover:bg-blue-700 focus:ring-blue-800">Update Quiz</button>
          </form>
        </div>
      </section>
    </Layout>
  )
}
